import { API_ROUTES } from "@/lib/config/api-routes";
import { ApiService } from "@/lib/services/api-service";
import type {
  MasterData,
  MasterDataApiResponse,
} from "@/lib/types/master-data";

class MasterDataService extends ApiService {
  fetchMasterData() {
    return this.get<MasterDataApiResponse>(API_ROUTES.masterData);
  }
}

export const masterDataService = new MasterDataService();

export type { MasterData };
